import { useEffect, useState } from 'react';
import useTextDevice from './useTextDevice.js';
import { wideDevice } from '../blocks/gallery-devices.js';

/**
 * The gallery device for this window: phone or tablet as text uses them,
 * and on desktop 'wide' or 'xwide' once the window and the page are both
 * wide enough. The server renders desktop ('base').
 * @param {number} [pageWidth] - the theme's layout width in px
 * @returns {'xwide'|'wide'|'base'|'tablet'|'phone'}
 */
export default function useGalleryDevice(pageWidth) {
    const device = useTextDevice();
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const read = () => setWidth(window.innerWidth);
        read();
        window.addEventListener('resize', read);
        return () => window.removeEventListener('resize', read);
    }, []);

    if (device === 'phone' || device === 'tablet') return device;
    return wideDevice(width, pageWidth);
}
